<template>
  <div class="page-container lottery-contain">
    <van-nav-bar
      v-if="!$route.query.terminal"
      class="lottery-nav"
      title=""
      fixed
      :z-index="10"
      @click-left="clickNavBack"
      left-arrow></van-nav-bar>
    <div class="lottery-content" @click="onJoin"></div>
  </div>
</template>
    <script>
import { mapGetters } from "vuex"
import { midautumnLoad } from "../../api/lottery"
import session from "../../utils/session"

export default {
  name: "lottery",
  components: {},
  data() {
    return {
      answer: false
    }
  },
  computed: {
    ...mapGetters(["channel", "userInfo"])
  },
  mounted() {
    if (this.channel.toLowerCase() != "ta") {
      this.$router.push({ name: "home" })
      return
    }
    setTimeout(() => {
      if (!this.userInfo.isAuthName) {
        this._showTipsInfo(
          "温馨提示",
          "您当前暂未实名，进行实名认证后即可参与活动哦",
          "去首页",
          "去实名",
          () => {
            session.setJson("cq", { target: "introduce" })
            this.$router.push({ name: "realname" })
          },
          () => {
            this.$router.push({ name: "home" })
          }
        )
      }
    }, 500)
    midautumnLoad()
      .then((data) => {
        if (data) {
          this.answer = data.answer
        }
      })
      .catch((e) => {
        this.$toast(e.msg || e.message)
      })
  },
  destroyed() {},
  methods: {
    clickNavBack() {
      this.goableBack()
    },
    onJoin() {
      if (this.answer) {
        this.$router.push({ name: "blindbox" })
      } else {
        this.$router.push({ name: "answerdraw" })
      }
    }
  }
}
</script>
    <style lang="less" scoped>
.lottery-nav {
  background-color: transparent;
  &::after {
    display: none;
  }
}
.lottery-content {
  background-image: url(../../assets/img/lottery/mid/mid_introduce_bg.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  min-height: 100vh;
  margin-top: -45px;
}
</style>